import { render, staticRenderFns } from "./WorkDetail17.vue?vue&type=template&id=12db4f33&scoped=true&"
import script from "./WorkDetail17.vue?vue&type=script&lang=js&"
export * from "./WorkDetail17.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetail17.vue?vue&type=style&index=0&id=12db4f33&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12db4f33",
  null
  
)

export default component.exports